<template>
  <div class="c-fl-bt">
    <div
      v-for="(v, i) in 5"
      :key="i"
    >
      <g-img
        v-if="i<num"
        :src="require('@/assets/images/start3.png')"
        size="20"
        :normal="true"
        class="c-p-r-10"
      ></g-img>
      <g-img
        v-else
        class="c-p-r-10"
        :src="require('@/assets/images/star3@2.png')"
        size="20"
        normal
      ></g-img>
    </div>
    <span class="c-p-l-10">{{num}}分</span>
  </div>
</template>

<script>
export default {
  name: "GStar",
  props: {
    num: {
      type: [Number, String],
      default: 5,
    }
  },
  data() {
    return {
        
    };
  },
  created() {

  },
  mounted() {

  },
  methods: {

  }
};
</script>
<style scoped lang='scss'>
</style>
